import { computed, ref } from 'vue'
import { defineStore } from 'pinia'

const useAuthStore = defineStore(
  'auth',
  () => {
    const accessToken = ref(/** @type { string|null} */ null)
    const client = ref(/** @type { string|null} */ null)
    const guid = ref(/** @type { string|null} */ null)
    const tokenType = ref(/** @type { string|null} */ null)
    const hasAuthError = ref(false)
    const hostClientAppId = ref(/** @type { string|null} */ null)
    const hostClientVersion = ref(/** @type { string|null} */ null)

    const isAuthenticated = computed(() => !!accessToken.value)

    const invalidateTokens = () => {
      accessToken.value = null
      client.value = null
      guid.value = null
      tokenType.value = null
    }

    return {
      accessToken,
      client,
      guid,
      tokenType,
      hasAuthError,
      hostClientAppId,
      hostClientVersion,
      isAuthenticated,
      invalidateTokens,
    }
  },
  {
    persist: {
      storage: sessionStorage,
      omit: ['hasAuthError'],
    },
  },
)

export default useAuthStore
